import * as Yup from "yup";


export const DepartmentSchema = Yup.object({
    department: Yup.string().required(" Enter Department"),
    status: Yup.string().required(" Select Status"),
});